import React from 'react';

import Clickable from './Clickable';
import Icon from './Icon';
import Layout from './Layout';
import Text from './Text';

interface Props {
  value: string;
  onRemove: () => void;
}

const EmailInlineTag: React.FC<Props> = ({ value, onRemove }) => {
  return (
    <Layout paddingLeft={8} paddingRight={2} paddingY={2} flex color="gray-50" borderRadius={4} align="center" gap={2}>
      <Text size="body-md" color="gray-900">
        {value}
      </Text>
      <Clickable onClick={() => onRemove()} style={{ display: 'inline-flex' }}>
        <Icon name="close" color="gray-900" size="sm" />
      </Clickable>
    </Layout>
  );
};

export default EmailInlineTag;
